import React from "react"
import {Chart} from 'primereact/chart';
import CSCOPieChart from './CSCOPieChart.js'
import CSCOBarChart from './CSCOBarChart.js'
import CSCOLineChart from './CSCOLineChart.js'
import { Dropdown } from "primereact/dropdown";

class CSCOReportChart extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = 
        {
            mReportData             : this.props.pReportData,
            mChartType              : null,
            mChartHeading           : null,
            mReportName             : null,
            mReportCriteria         : this.props.pReportCriteria,
            mReportChart            : this.props.pReportChart,
            mReportChartProperties  : this.props.pReportChartProperties,
            mDataCollection         : this.props.pDataCollection,
            mReport                 : null,
            mIsDashboardReport      : this.props.pIsDashboardReport,
            mHeight                 : this.props.pHeight || null,
            mCriteriaList           : [],
            mCriteriaDropdowns      : {},
            mCriteriaValues         : {},
            mFilteredDataCollection : this.props.pDataCollection || []
        }

        this.cfInitializeReport = this.cfInitializeReport.bind(this);
        this.cfOnCriteriaChange = this.cfOnCriteriaChange.bind(this);
    }

    componentDidMount()
    {
        this.cfInitializeReport();
    }

    componentDidUpdate(lPrevProps)
    {
        if (
            lPrevProps.pReportData            !== this.props.pReportData ||
            lPrevProps.pReportChart           !== this.props.pReportChart ||
            lPrevProps.pReportChartProperties !== this.props.pReportChartProperties ||
            lPrevProps.pDataCollection        !== this.props.pDataCollection
        )
        {
            this.cfInitializeReport();
        }
    }

    cfInitializeReport()
    {
        var lReportData = this.props.pReportData;
        var lReport = null;
        if(lReportData)
        {
            const lProps = 
            {
                pReportData             : lReportData,
                pReportChart            : this.props.pReportChart,
                pReportChartProperties  : this.props.pReportChartProperties,
                pIsDashboardReport      : this.props.pIsDashboardReport,
                pDataCollection         : this.props.pDataCollection,
                pIsReportCriteria       : (this.props.pParent && this.props.pParent.state.mReportCriteriaData) ? true : false,
                pChartType              : lReportData.chart_type_
            }
        
            switch(lReportData.chart_type_)
            {
                case 'PIE':
                    lReport = <CSCOPieChart {...lProps} />
                break;
    
                case 'BAR':
                case 'COLUMN': 
                case 'MULTI_AXIS': 
                case 'STACKED': 
                    lReport = <CSCOBarChart {...lProps} />
                break;
    
                case 'AREA':
                    lReport = <Chart type="polarArea" data={lReportData} />
                break;

                case 'LINE':
                    lReport = <CSCOLineChart {...lProps} />
                break;

                case 'DOUGHNUT':
                    lReport = <Chart type="doughnut" data={lReportData} />
                break;

                case 'RADAR':
                    lReport =   
                        <div className="content-section implementation">
                            <Chart type="radar" data={lReportData} />
                        </div>
                break;

                case 'COMBO':
                    lReport = 
                        <div className="content-section implementation">
                            <Chart type="bar" data={lReportData} />
                        </div>
                break;

                default:
                break;
            }

            const lAllData = this.props.pDataCollection || [];
            const lChartProps = this.props.pReportChartProperties || [];
            const lCriteriaList = [];
            const lCriteriaDropdowns = {};
            const lCriteriaValues = {};

            for (let lInd = 1; lInd <= 3; lInd++) {
                const lFieldPropName  = `criteria_field_${lInd}_`;
                const lLabelPropName  = `criteria_label_${lInd}_`;

                const lFieldProp = lChartProps.find(lParam => lParam.property_name_ === lFieldPropName);
                if (!lFieldProp) continue;

                const lLabelProp = lChartProps.find(lParam => lParam.property_name_ === lLabelPropName);
                const lFieldName = lFieldProp.value_;
                const lFieldLabel = lLabelProp ? lLabelProp.value_ : lFieldName;

                lCriteriaList.push({ field: lFieldName, label: lFieldLabel });

                const lValueSet = new Set();
                lAllData.forEach(lRec => {
                    if (lRec && lRec[lFieldName] != null) {
                        lValueSet.add(lRec[lFieldName]);
                    }
                });
                
                const lOptions = Array.from(lValueSet).map(lValue => ({
                    label: String(lValue),
                    value: lValue
                }));

                lCriteriaDropdowns[lFieldName] = lOptions;
                if (lOptions.length > 0) {
                    lCriteriaValues[lFieldName] = lOptions[0].value;
                }
            }

            let lFilteredData = lAllData;
            if (Object.keys(lCriteriaValues).length > 0) {
                lFilteredData = lAllData.filter(rec => {
                    if (!rec) return false;
                    return Object.entries(lCriteriaValues).every(([field, val]) => {
                            if (val === null || val === undefined || val === '') return true;
                            return rec[field] === val;
                        });
                    }
                );
            }
    
            this.setState(
                {
                    mReport                 : lReport, 
                    mReportData             : this.props.pReportData,
                    mColumns                : this.props.pColumns,
                    mPrintFlag              : this.props.pPrintFlag,
                    mDataCollection         : this.props.pDataCollection,
                    mChartHeading           : lReportData.report_heading_, 
                    mChartType              : lReportData.chart_type_, 
                    mReportName             : lReportData.report_name_,
                    mIsDashboardReport      : this.props.pIsDashboardReport,
                    mCriteriaList           : lCriteriaList,
                    mCriteriaDropdowns      : lCriteriaDropdowns,
                    mCriteriaValues         : lCriteriaValues, 
                    mFilteredDataCollection : lFilteredData
                }
            );
        }
    }

    cfOnCriteriaChange(pField, pValue)
    {
        const lAllData = this.props.pDataCollection || [];
        const lCriteriaValues = { ...this.state.mCriteriaValues, [pField]: pValue };
        const lFiltered = lAllData.filter(rec => {
            if (!rec) return false;
            return Object.entries(lCriteriaValues).every(([field, val]) => {
                if (!val && val !== 0) return true;
                return rec[field] === val;
            });
        });

        this.setState({
            mCriteriaValues         : lCriteriaValues,
            mFilteredDataCollection : lFiltered
        });
    }

    render()
    {
        const isBarType =
            this.state.mChartType === 'BAR'     ||
            this.state.mChartType === 'COLUMN'  ||
            this.state.mChartType === 'MULTI_AXIS' ||
            this.state.mChartType === 'STACKED';

        const hasCriteria =
            this.state.mCriteriaList &&
            this.state.mCriteriaList.length > 0;

        const anyCriteriaSelected = hasCriteria && this.state.mCriteriaValues &&
            Object.values(this.state.mCriteriaValues).some( v => v !== null && v !== undefined && v !== '' );

        const lDataToUse = (this.state.mFilteredDataCollection && this.state.mFilteredDataCollection.length > 0)
            ? this.state.mFilteredDataCollection
            : (this.state.mDataCollection || []);

        const lCriteriaControls = this.state.mCriteriaList.map((crit, idx) => (
            <Dropdown
                key        = { crit.field }
                value      = { this.state.mCriteriaValues[crit.field] || null }
                options    = { this.state.mCriteriaDropdowns[crit.field] || [] }
                onChange   = { (e) => this.cfOnCriteriaChange(crit.field, e.value) }
                placeholder= { `Select ${crit.label}` }
                optionLabel= "label"
                optionValue= "value"
                style      = {{ width: '180px', fontSize: '12px', marginLeft: idx ? '0.5rem' : '0' }}
            />
        ));

        const lFloatingFilterBar = (isBarType && hasCriteria)
            ? (
                <div
                    style={{
                        position    : 'absolute',
                        right       : '0.75rem',
                        zIndex      : 10,
                        background  : 'rgba(255,255,255,0.9)',
                        padding     : '0.25rem 0.25rem',
                        borderRadius: '4px',
                        boxShadow   : '0 0 4px rgba(0,0,0,0.15)',
                        display     : 'flex'
                    }}
                >
                    {lCriteriaControls}
                </div>
            )
            : null;

        let lChartBody;
        if (isBarType) {
            if (!hasCriteria || anyCriteriaSelected) {
                lChartBody = (
                    <CSCOBarChart
                        pDataCollection        = {lDataToUse}
                        pReportChartProperties = {this.props.pReportChartProperties}
                        pReportData            = {this.state.mReportData}
                        pIsDashboardReport     = {this.state.mIsDashboardReport}
                    />
                );
            } else {
                lChartBody = (
                    <div
                        style={{
                            height        : '100px',
                            display       : 'flex',
                            alignItems    : 'center',
                            justifyContent: 'center',
                            fontSize      : '0.9rem',
                            color         : '#666',
                            border        : '1px dashed #ccc',
                            borderRadius  : '8px',
                            marginTop     : '0.25rem'
                        }}
                    >
                        Please select criteria to view the chart.
                    </div>
                );
            }
        } else {
            lChartBody = this.state.mReport;
        }

        const lStyle = {
            position: 'relative',
            width: '100%'
        };

        return (
            <div style={lStyle}>
                {lFloatingFilterBar}
                {lChartBody}
            </div>
        );
    }
}

export default CSCOReportChart;